/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { JobProgramMilestone } from '../models/JobProgramMilestone';
import type { Programs } from '../models/Programs';
import type { TaskDependencyGraph } from '../models/TaskDependencyGraph';
import type { TaskName } from '../models/TaskName';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TaskGraphRoutesRepository {
  /**
   * Get Task Dependency Graph
   * Get graph (nodes and edges) for downstream dependents of a task.
   * @returns TaskDependencyGraph Successful Response
   * @throws ApiError
   */
  public static taskGraphRoutesGetTaskDependencyGraph({
    programs,
    milestones,
    authorization,
  }: {
    programs?: Array<Programs>,
    milestones?: (Array<JobProgramMilestone> | null),
    authorization?: string,
  }): CancelablePromise<TaskDependencyGraph> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/task-graph/',
      headers: {
        'authorization': authorization,
      },
      query: {
        'programs': programs,
        'milestones': milestones,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Downstream Dependents Graph
   * Get graph (nodes and edges) for downstream dependents of a task.
   * @returns TaskDependencyGraph Successful Response
   * @throws ApiError
   */
  public static taskGraphRoutesGetDownstreamDependentsGraph({
    program,
    taskName,
    authorization,
  }: {
    program: Programs,
    taskName: TaskName,
    authorization?: string,
  }): CancelablePromise<TaskDependencyGraph> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/task-graph/program/{program}/tasks/{task_name}',
      path: {
        'program': program,
        'task_name': taskName,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
